import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import posthog from "posthog-js";

const CONSENT_KEY = "lf_analytics_consent_v1";
const POSTHOG_KEY = "phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs";

function clearPostHogStorage() {
  Object.keys(window.localStorage).filter((key) => key.toLowerCase().includes("posthog")).forEach((key) => window.localStorage.removeItem(key));
  document.cookie.split(";").map((item) => item.trim().split("=")[0]).filter((name) => name.startsWith("ph_")).forEach((name) => {
    document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
    document.cookie = `${name}=; Max-Age=0; path=/; domain=.lightningflow.ai; SameSite=Lax`;
  });
}

function startPostHog() {
  if (!POSTHOG_KEY) return;
  if (posthog.__loaded) {
    posthog.set_config({ persistence: "localStorage+cookie" });
    posthog.opt_in_capturing();
    posthog.capture("$pageview");
    return;
  }
  posthog.init(POSTHOG_KEY, {
    api_host: "https://us.i.posthog.com",
    person_profiles: "identified_only",
    persistence: "localStorage+cookie",
    autocapture: false,
    capture_pageview: true,
    disable_session_recording: true,
    capture_performance: false,
    capture_dead_clicks: false,
    disable_surveys: true,
    disable_external_dependency_loading: true,
    advanced_disable_feature_flags: true,
    respect_dnt: true,
  });
}

export default function AnalyticsConsent() {
  const [choice, setChoice] = useState(() => window.localStorage.getItem(CONSENT_KEY));
  const [settingsOpen, setSettingsOpen] = useState(false);

  useEffect(() => {
    if (choice === "accepted") startPostHog();
  }, [choice]);

  useEffect(() => {
    const openSettings = () => setSettingsOpen(true);
    window.addEventListener("lf:privacy-settings", openSettings);
    return () => window.removeEventListener("lf:privacy-settings", openSettings);
  }, []);

  const save = (nextChoice) => {
    window.localStorage.setItem(CONSENT_KEY, nextChoice);
    setChoice(nextChoice);
    setSettingsOpen(false);
    if (nextChoice === "accepted") startPostHog();
    else {
      if (posthog.__loaded) {
        posthog.reset();
        posthog.opt_out_capturing();
      }
      clearPostHogStorage();
    }
  };

  if (choice && !settingsOpen) return null;

  return (
    <div className="fixed inset-x-3 bottom-3 z-[100] border border-ink-200 bg-white p-4 shadow-[0_20px_70px_rgba(3,17,36,.22)] sm:left-auto sm:right-5 sm:w-[min(440px,calc(100vw-2.5rem))] sm:p-5" role="dialog" aria-label="Analytics privacy choices" data-testid="analytics-consent">
      <div className="flex flex-col gap-4">
        <div>
          <div className="font-display text-base font-bold text-ink-900">Your privacy choices</div>
          <p className="mt-1 text-sm leading-relaxed text-ink-600">
            Optional PostHog analytics loads only if you accept. Core site access and cookie-free Cloudflare performance analytics remain available. Read our <Link className="underline" to="/privacy">Privacy Policy</Link>.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <button type="button" className="lf-btn-secondary px-3" onClick={() => save("rejected")}>Reject optional</button>
          <button type="button" className="lf-btn-primary px-3" onClick={() => save("accepted")}>Accept analytics</button>
        </div>
      </div>
    </div>
  );
}
